import { app } from '../../../app';

app.component('customError', {
    bindings: {errorMessage: '<'},
    templateUrl: require('./custom-error.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/custom-error/custom-error.component.js